export default "__VITE_ASSET__BbVwL_GC__"